/* eslint-disable prettier/prettier */
/* eslint-disable no-param-reassign */
/* eslint-disable react/no-string-refs */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/extensions */
import React, { useState } from "react";
import styled, { css } from "styled-components";
import Checkbox from "@material-ui/core/Checkbox";
import { useTranslation } from 'react-i18next';

import {
  DiamondSm,
  WhiteMan as WhiteSource,
  RedMan as RedSource,
  GreenMan as GreenSource,
  GrayCheckMark,
  CheckboxCheckmark,
  EmptyCheckbox,
  Rectangle13,
  CheckboxActive,
} from "../../Constants/assets";

// General PM Tasks css

const TasksContainer = styled.div`
  border: 1px solid ${(props) => props.theme.colors.whiteSmoke};
  box-sizing: border-box;
  box-shadow: 0px 2px 10px 2px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  width: 100%;
  height: 72px;
  display: flex;
  justify-content: space-evenly;
  margin-bottom: 8px;
  background-color: #ffffff;
`;
const CenterInformation = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 37%;
  align-self: center;
`;
const InformationContainer = styled.div`
  display: grid;
`;
const TaskTitle = styled.div`
  font-weight: 500;
  font-size: 15px;
  align-self: center;
  width: 200px;
  text-align: start;
`;
const InformationTitle = styled.div`
  font-weight: normal;
  font-size: 12px;
  color: ${(props) => props.theme.colors.gray};
`;
const InformationDetail = styled.div`
  font-weight: 500;
  font-size: 21px;
  display: flex;
`;
const AdditionalInformation = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.colors.orange};
  background: RGB(252, 157, 44, 0.1);
  border-radius: 4px;
  width: 277px;
  height: 34px;
  padding: 3px;
  align-self: center;
`;
const ResourcesComponent = styled.div`
  display: flex;
`;
const CheckMarksComponent = styled.div`
  align-self: center;
  width: 8%;
  display: flex;
  justify-content: center;
`;

const CardCheckbox = styled(Checkbox)`
  /* && {
        position: absolute;
        right: 0;
    } */
  && {
    height: 44px;
    margin: auto 0;
  }
`;

export default function GeneralTasks({
  id,
  performPlannedTask,
  checkedTaskHandler,
  generalTask,
  name,
  cost,
  grayAmount,
  redAmount,
  blueAmount,
  generalTaskChecked,
  earnedValue,
  steps,
  alert,
  amountOfV,
  showIsPaused,
  currentTileType,
}) {
  // const [checkedTask, setCheckedTask] = useState(false);
  // console.log('showIsPaused:', showIsPaused);
  const { t } = useTranslation();

  return (
    <TasksContainer /* onClick={() => performPlannedTask(id + 1, false, 'general')} */
    >
      <CardCheckbox
        color="black"
        disabled={showIsPaused}
        onChange={() => checkedTaskHandler(id, false, id)}
        checked={generalTaskChecked.includes(id)}
        icon={
          <Rectangle13
            style={{ width: "24px", height: "24px", transform: "scale(0.9)" }}
          />
        }
        checkedIcon={
          <CheckboxActive style={{ width: "24px", height: "24px" }} />
        }
      />
      <TaskTitle> {t(`project_sheet.general_tasks.task${id}.general_task_title`, {id} )} </TaskTitle>
      <CenterInformation>
        <InformationContainer>
          <InformationTitle>{t(`global_variables.cost`)}</InformationTitle>
          <InformationDetail>${cost}</InformationDetail>
        </InformationContainer>
        <InformationContainer>
          <InformationTitle>{t(`global_variables.resources.resources`)}</InformationTitle>
          <InformationDetail>
            <ResourcesComponent>
              <WhiteSource style={{ marginRight: "2px" }} />
              <InformationDetail style={{ fontSize: "14px" }}>
                {grayAmount} &nbsp;
              </InformationDetail>
            </ResourcesComponent>
            <ResourcesComponent>
              <RedSource style={{ marginRight: "2px" }} />
              <InformationDetail style={{ fontSize: "14px" }}>
                {redAmount} &nbsp;
              </InformationDetail>
            </ResourcesComponent>
            <ResourcesComponent>
              <GreenSource style={{ marginRight: "2px" }} />
              <InformationDetail style={{ fontSize: "14px" }}>
                {blueAmount} &nbsp;
              </InformationDetail>
            </ResourcesComponent>
          </InformationDetail>
        </InformationContainer>
        <InformationContainer>
          <InformationTitle>{t(`global_variables.value`)}</InformationTitle>
          <InformationDetail>
            {earnedValue} &nbsp; <DiamondSm style={{ alignSelf: "center" }} />
          </InformationDetail>
        </InformationContainer>
        <InformationContainer>
          <InformationTitle>{t(`global_variables.steps`)}</InformationTitle>
          <InformationDetail>{steps}</InformationDetail>
        </InformationContainer>
      </CenterInformation>
      <AdditionalInformation>{t(`project_sheet.general_tasks.task${id}.info_text`, {id} )}</AdditionalInformation>
      <CheckMarksComponent>
        {Array.from(Array(generalTask[id - 1])).map((index) => {
          return <GrayCheckMark key={index} style={{ marginRight: "-8.5%" }} />;
        })}
      </CheckMarksComponent>
    </TasksContainer>
  );
}
